module.exports = __webpack_public_path__ + "img/telemetrias.c8f0d525.png";